import { campaignAdProductLabel, type SpCampaignNormalized } from '@/types/spCampaigns';

export const CAMPAIGN_SEARCH_PLACEHOLDER =
  'Search name, ID, or ad product — all words must match';

/** Lowercase, trim, collapse spaces, strip combining marks (e.g. café → cafe) for forgiving search. */
export function normalizeForCampaignSearch(s: string): string {
  return s
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

export function parseCampaignSearchTokens(raw: string): string[] {
  const collapsed = normalizeForCampaignSearch(raw);
  if (!collapsed) return [];
  return collapsed.split(' ');
}

/** Every token must appear somewhere in name, id, or ad product label (substring, order-independent). */
export function campaignMatchesSearchQuery(
  c: SpCampaignNormalized,
  tokens: string[]
): boolean {
  if (tokens.length === 0) return true;
  const haystack = normalizeForCampaignSearch(
    `${c.name || ''} ${c.campaignId || ''} ${campaignAdProductLabel(c.adProduct)} ${c.adProduct}`
  );
  return tokens.every((t) => haystack.includes(t));
}

export function filterCampaignsBySearch(
  campaigns: SpCampaignNormalized[],
  raw: string,
  limit = 50
): SpCampaignNormalized[] {
  const tokens = parseCampaignSearchTokens(raw);
  const matched =
    tokens.length === 0
      ? campaigns
      : campaigns.filter((c) => campaignMatchesSearchQuery(c, tokens));
  return matched.slice(0, limit);
}
